import { GET_LIST } from "react-admin";

const AnswerSearchProvider = opt => {
  const { config } = opt;
  if (!config) {
    throw new Error("Missing config");
  }
  const client = config.algoliaClient();
  const index = client.initIndex("answers");
  const provider = {
    config,
    client,
    index,
    handle(type, params) {
      switch (type) {
        case GET_LIST:
          return provider.list(params);
        default:
          throw new Error(`Unsupported action type: ${type}`);
      }
    },
    list(params) {
      if (!params.filter.q) {
        throw new Error(`Missing search filter param: ${params.filter}`);
      }
      const searchPromise = new Promise((resolve, reject) => {
        provider.index.search({ query: params.filter.q }, (err, content) => {
          if (err) {
            reject(err);
            return;
          }
          let answers = content.hits;
          if (params.filter) {
            if (params.filter.board && params.filter.board.id) {
              answers = answers.filter(
                q => q.board.id === params.filter.board.id
              );
            }
          }
          const response = {
            data: answers,
            total: answers.length
          };
          resolve(response);
        });
      });
      return searchPromise;
    }
  };
  return provider;
};

export default AnswerSearchProvider;
